<div class="widget__wrap">
    <div class="widget" id="{{ url }}-widget" style="position: relative;">
        <h2 class="widget__header">
            <span class="widget__header__title">
                <i class="widget__header__icon ico-angle-down"></i>
                <span [innerHTML]="headerTitle"></span>
            </span>
        </h2>
        <div class="widget__content" *ngIf="isInitialized">
            <form [formGroup]="form" (ngSubmit)="save()" [method]="'post'">
                <swb-form-fields [fields]="formEditors" [form]="form"></swb-form-fields>
                <div class="widget__submit">
                    <button type="submit" class="cta cta--blue submit" [ngClass]="{'submit--submitting': isSaving}"
                        [disabled]="isSaving">
                        <i class="ico-save"></i> Uložit</button>
                </div>
            </form>
        </div>
        <div *ngIf="!isInitialized" class="widget__content loading"></div>
    </div>
</div>